import { ChatRealtimeClient } from "./chat-realtime.js";

/** 流程群与真人、Agent共用页面连接；消息仍按序号从成员鉴权接口补齐。 */
export class WorkflowChatRealtimeClient extends ChatRealtimeClient {
  constructor(options) {
    super({ ...options, locationLike: options.location || options.locationLike || globalThis.location,
      subscriptions: [{ channel: "workflow-chat", resourceId: "self" }] });
  }
}
